import { AnyObject } from 'immer/dist/internal';

/**
 * @param {AnyObject} 쿼리이름 key, 쿼리값 value 형태인 객체
 * @returns {string} ?key1=value1&key2=value2... 형태의 문자열
 */
const createQueryPath = (queryObject: AnyObject): string => {
  const queryPath = Object.entries(queryObject)
    .map(([queryName, queryValue]) => `${queryName}=${queryValue}`)
    .join('&');
  return `?${queryPath}`;
};

export default createQueryPath;
